module.exports = __webpack_public_path__ + "static/media/pic-st5.adb36eb6.jpg";